<template>
  <div class="page-vip-detail-container">
    <customize-header v-if="loaded"
                      class="page-vip-detail"
    >
      <template #header>
        <top-bar class="page-vip-detail-top-bar"
                 :show-header="!isAppWebView"
                 back-color="#fff"
        />
      </template>

      <bottom-bar-layout :show-bar="render.bottomBar.show"
                         :bar-height="render.benefitBar && render.benefitBar.show ? 180 : 120"
                         :target-id="vip.id"
                         target-type="vip"
                         :show-consult="false"
                         :is-show-guide-popup="false"
      >
        <vip-detail-content :vip="vip"
                            :primary-price="render.primaryPrice"
                            :group-buy="groupBuy"
        />

        <template #tabbar>
          <bottom-bar :product="product"
                      :benefit-bar="render.benefitBar"
                      :show-gift="showGift"
                      :disabled-gift="disabledGift"
                      :show-consult="render.showConsult"
                      :show-entrance="render.showEntrance"
                      :sell="vip.sell"
                      :render-price="render.bottomBar.renderPrice"
                      :action-bar="render.bottomBar.actionBar"
                      :my-team-id="groupBuy.myTeamId"
                      @click-gift="handleClickGift"
          />
        </template>

        <confirm-pay-popup :show.sync="showPayPopup"
                           :target-id="benefitPopupTargetId"
                           :target-type="benefitPopupTargetType"
                           :title="benefitPopupTargetTitle"
                           :recommend="mixinRecommendBenefit"
                           :benefits="mixinBenefits"
                           :price="mixinShouldPay"
                           :rule="mixinPopupPayRule"
        />
      </bottom-bar-layout>
    </customize-header>
    <empty-page v-else
                hint="正在加载数据..."
    />
  </div>

</template>

<script>
  import EmptyPage from '@/components/EmptyPage';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';
  import TopBar from '@/components/TopBar';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import BottomBar from '@/pages/Vip/components/VipDetailBottomBar';
  import VipDetailContent from '@/pages/Vip/components/VipDetailContent';
  import ConfirmPayPopup from '@/components/ConfirmPayPopup';
  import { getVipDetail } from '@/services/vip';
  import joinProductMixin from '@/mixins/order/joinProduct';
  import { isAppWebView } from '@/utils';

  export default {
    name: 'PageVipDetail',
    metaInfo: {},
    mixins: [joinProductMixin],
    components: {
      EmptyPage,
      CustomizeHeader,
      TopBar,
      BottomBarLayout,
      BottomBar,
      VipDetailContent,
      ConfirmPayPopup,
    },
    data() {
      return {
        isAppWebView: isAppWebView(),
        loaded: false,
        disabledGift: false,
        vip: {
          id: 0,
          headerCover: '',
          type: '',
          about: '',
          price: 0,
          sell: {
            startTime: '',
            status: '',
          },
        },

        groupBuy: {
          activity: null,
          myTeamId: 0,
        },

        render: {
          primaryPrice: {
            current: {
              value: 0,
              name: '',
            },
            origin: {
              value: 0,
              name: '',
            },
            benefit: null,
          },
          benefitBar: null,
          bottomBar: {
            show: false,
            actionBar: {
              type: 'default',
              buttons: [],
            },
            renderPrice: {
              value: 0,
              delete: 0,
              name: '',
            },
          },
          showConsult: false,
          showEntrance: false,
          gift: {
            show: false,
            price: 0,
          },
        },
      };
    },
    computed: {
      gift() {
        return this.render.gift;
      },
      showGift() {
        const { gift } = this;
        return gift && gift.show;
      },
      product() {
        return {
          id: this.vip.id,
          price: this.render.primaryPrice.origin.value,
        };
      },
    },
    methods: {
      async fetchData() {
        const { id } = this.$route.params;
        const data = await getVipDetail(id);

        this.vip = data.vip;
        this.groupBuy = data.groupBuy;
        this.render = data.render;
        this.loaded = true;
      },
      async handleClickGift() {
        this.disabledGift = true;
        try {
          this.mixinOriginPrice = this.gift.price;
          this.mixinHandleClickJoinBtn({
            targetId: this.gift.targetId,
            targetType: this.gift.targetType,
          });
          this.disabledGift = false;
        } catch (e) {
          this.mixinOriginPrice = this.vip.price;
          this.disabledGift = false;
        }
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-vip-detail {
    &-container {
      min-height: 100%;
      background: @color-white;
    }
    &-top-bar {
      /deep/ .ym-header {
        background: @vip-detail-background;

        &::after {
          border: none;
        }
      }
    }
  }
</style>
